/** Detecção de dispositivo físico — independente do viewport (modo desktop do navegador). */

export function getPhysicalScreenMin(): number {
  if (typeof window === 'undefined') return 1024;
  return Math.min(window.screen.width, window.screen.height);
}

export function hasTouchInput(): boolean {
  if (typeof window === 'undefined') return false;
  return navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
}

/** Smartphone (tela física pequena + touch). Ignora viewport em "site para computador". */
export function isPhoneLikeDevice(): boolean {
  return hasTouchInput() && getPhysicalScreenMin() <= 600;
}

/** Celular com "Site para computador" — viewport largo em tela pequena. */
export function isDesktopSiteModeOnPhone(): boolean {
  if (!isPhoneLikeDevice()) return false;
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= 768;
}

export function syncPhoneDocumentFlag(): void {
  if (typeof document === 'undefined') return;
  if (isPhoneLikeDevice()) {
    document.documentElement.setAttribute('data-klinvia-phone', '1');
  } else {
    document.documentElement.removeAttribute('data-klinvia-phone');
  }
}
